import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const [content, setContent] = useState(null);
  const [groups, setGroups] = useState([]);

  const refresh = useCallback(async () => {
    const [c, g] = await Promise.all([axios.get(`${API}/content`), axios.get(`${API}/groups`)]);
    setContent(c.data);
    setGroups(g.data);
  }, []);

  useEffect(() => {
    refresh().catch(() => {});
  }, [refresh]);

  if (!content) {
    return (
      <div className="min-h-screen grid place-items-center bg-ivory" data-testid="site-loading">
        <div className="h-10 w-10 rounded-full border-2 border-brand border-t-transparent animate-spin" />
      </div>
    );
  }
  return <SiteContext.Provider value={{ content, groups, refresh }}>{children}</SiteContext.Provider>;
};

export const useSite = () => useContext(SiteContext);
